import { supabase } from './supabase.js';
import { StorageError } from '@supabase/storage-js';

export async function uploadFile(file: File, userId: string, bucket: 'uploads' | 'recordings' | 'thoughts' = 'uploads') {
  try {
    const timestamp = new Date().getTime();
    const filePath = `${userId}/${timestamp}-${file.name}`;

    const { data, error } = await supabase.storage
      .from(bucket)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false,
      });

    if (error) {
      console.error('File upload error:', error.message);
      throw new Error(error.message);
    }

    console.log(`File uploaded successfully to ${bucket}:`, data.path);
    return data;
  } catch (error) {
    if (error instanceof StorageError) {
      console.error('Storage error:', error.message);
      throw new Error(`Storage error: ${error.message}`);
    }
    console.error('Upload error:', error);
    throw new Error('Failed to upload file. Please try again.');
  }
}

export async function getFileUrl(filePath: string, bucket: 'uploads' | 'recordings' | 'thoughts' = 'uploads') {
  try {
    console.log(`Attempting to get signed URL for file: ${filePath} from bucket: ${bucket}`);
    
    const { data, error } = await supabase.storage
      .from(bucket)
      .createSignedUrl(filePath, 300); // 5 minutes expiry

    if (error) {
      console.error('Signed URL error:', error.message);
      throw error;
    }

    if (!data?.signedUrl) {
      throw new Error('No signed URL generated');
    }

    console.log(`Successfully generated signed URL for ${bucket}/${filePath}`);
    return data.signedUrl;
  } catch (error) {
    console.error('Error generating file URL:', error);
    throw error;
  }
}